import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import AppLayout from "../layout/appLayout";
import Login from "./login";

const App = () => {
  const [login, setLogin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (localStorage.getItem("GIRNAR_TOKEN")) {
      setLogin(true);
      setLoading(false);
    } else {
      setLogin(false);
      setLoading(false);
    }
  }, []);

  if (loading)
    return (
      <div
        style={{
          width: "100vw",
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <span className="loader"></span>
      </div>
    );

  if (login)
    return (
      <AppLayout>
        <Outlet />
      </AppLayout>
    );

  return <Login />;
};

export default App;
